// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uploaded-document-pdf{text-align:center}.uploaded-document-pdf__image{max-width:90%}.uploaded-document-pdf__embed{width:90%;min-height:50vw}.uploaded-document-pdf__open-button{text-align:center;display:block;padding:10px 0}", ""]);
// Exports
module.exports = exports;
